import { useTranslation } from 'react-i18next';
import { Checkbox } from 'Components';
import { useFormikContext } from 'formik';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { AddGroupValues } from 'Pages/Group/Group.types';

function AutoactivateField() {
	const { t } = useTranslation();
	const { setFieldValue } = useFormikContext<AddGroupValues>();

	return (
		<>
			<Checkbox.FormikField name="autoactivate"
						onChange={(e: CheckboxChangeEvent) => {
							if (e.target.checked) {
								setFieldValue('resendActivationEmail', false);
							}
						}}>
				{t(`users.components.autoActiveModal.btnText`)}
			</Checkbox.FormikField>
		</>
	);
}

export default AutoactivateField;
